export default __webpack_public_path__ + "static/media/1inch.f7c0e554.webp";